import serviceHandler from "@/helpers/handlers/service";
import facilitiesService from "@/services/facilities";
import {
  SERVICE_ACTIONS_ENUM,
  SERVICE_EDIT_ORIGIN_ENUM
} from "@/enums/gmb-services.enum";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

const gmbServicesMixin = {
  data() {
    return {
      isLoading: false
    };
  },
  methods: {
    async patchFacilityService(serviceItems) {
      try {
        this.isLoading = true;
        const response = await serviceHandler(
          facilitiesService.patchFacility(this.$route.params.id, serviceItems)
        );
        if (response) {
          this.$emit("update", response);
          this.$notify({
            group: "default",
            type: "success",
            text: this.$t("message.notification.changesSaved")
          });
        }
      } catch (error) {
        this.$notify({
          group: "default",
          type: "error",
          text: this.$t("message.error.other")
        });
      } finally {
        this.isLoading = false;
      }
    },
    detectChangesAndSendEvent(editedItems, initialServices) {
      const gtmEventParams = this.prepareGtmEventParams(
        editedItems,
        initialServices
      );
      this.$gtm.trackCustomEvent(gtmEventParams);
    },
    prepareGtmEventParams(editedItems, initialServices) {
      const newServicesCount = this.getServicesCountPerAction(
        editedItems,
        SERVICE_ACTIONS_ENUM.CREATE
      );
      const updatedServicesCount = this.getServicesCountPerAction(
        editedItems,
        SERVICE_ACTIONS_ENUM.UPDATE
      );
      const deletedServicesCount = this.getServicesCountPerAction(
        editedItems,
        SERVICE_ACTIONS_ENUM.DELETE
      );

      const updatedItems = editedItems.service_items.filter(
        item => item.action === SERVICE_ACTIONS_ENUM.UPDATE
      );

      const updatedPriceCount = this.getServicesCountPerUpdatedField(
        updatedItems,
        initialServices,
        "price"
      );
      const updatedDescriptionCount = this.getServicesCountPerUpdatedField(
        updatedItems,
        initialServices,
        "description"
      );
      const updatedNameCount = this.getServicesCountPerUpdatedField(
        updatedItems,
        initialServices,
        "display_name"
      );
      return {
        event: GTM_EVENT_NAME.SERVICES_EDIT,
        location_id: this.$route.params.id,
        origin: this.getServiceOrigin(initialServices),
        num_services_added: newServicesCount,
        num_services_edited: updatedServicesCount,
        num_services_deleted: deletedServicesCount,
        num_services_edited_price: updatedPriceCount,
        num_services_edited_desc: updatedDescriptionCount,
        num_services_edited_name: updatedNameCount
      };
    },
    getServiceOrigin(initialServices) {
      if (!Array.isArray(initialServices)) {
        return SERVICE_EDIT_ORIGIN_ENUM.SINGLE_SERVICE;
      }
      return SERVICE_EDIT_ORIGIN_ENUM.SERVICES_CATEGORY;
    },
    getInitialItem(initialServices, id) {
      if (!Array.isArray(initialServices)) {
        return initialServices;
      }
      return initialServices.find(i => i.id === id);
    },
    getServicesCountPerAction(editedItems, action) {
      if (!editedItems.service_items || !editedItems.service_items.length) {
        return 0;
      }
      return editedItems.service_items.filter(item => item.action == action)
        .length;
    },
    getServicesCountPerUpdatedField(editedItems, initialServices, field) {
      if (!editedItems.length) {
        return 0;
      }
      const updatedItems = [];
      for (const { item } of editedItems) {
        const initialItem = this.getInitialItem(initialServices, item.id);
        const itemField = item[field];
        const initialItemField = initialItem[field];
        if (
          (!itemField && initialItemField) ||
          (itemField && itemField !== initialItemField)
        ) {
          updatedItems.push(item);
        }
      }
      return updatedItems.length;
    }
  }
};

export default gmbServicesMixin;
